<template>
  <div class="blog-post">
    <h1 class="blog-post-title margin-top-25">USA Parcel Pricing Calculator</h1>
    <p>Pembina, ND to Winnipeg, MB</p>
    <hr/>
    <div class="row">
      <div id="pricingCalculator" class="col-md-10">
        <form class="form-horizontal">
          <div class="form-group">
            <label for="shipment_weight" class="col-sm-4 control-label">Shipment Weight (lbs)</label>
            <div class="col-sm-8">
              <select id="shipment_weight" name="shipment_weight" class="form-control" v-model.number="shipment_weight" required>
                <option v-for="weightRange in weightLookup" :value="weightRange.price">{{weightRange.min + 1}}-{{weightRange.max}}</option>
              </select>
            </div>
          </div>

          <div class="form-group" v-if="shipment_weight < 0">
            <label for="shipment_weight_other" class="col-sm-4 control-label">Total weight lbs</label>
            <div class="col-sm-8">
              <input id="shipment_weight_other" type="number" class="form-control" name="shipment_weight_other" v-model.number="shipment_weight_other">
            </div>
          </div>

          <div class="form-group">
            <label for="shipment_value" class="col-sm-4 control-label">Shipment Value (CA$)</label>
            <div class="col-sm-8">
              <select id="shipment_value" name="shipment_value" class="form-control" v-model.number="shipment_value" required>
                <option v-for="fee in clearanceFeeLookup" :value="fee.price">${{fee.min + 1}}-{{fee.max}}</option>
                <option value="-1">${{ clearanceFeeLookup[clearanceFeeLookup.length - 1].max + 1 }}+</option>
              </select>
            </div>
          </div>

          <div class="form-group" v-if="shipment_value < 0">
            <label for="shipment_value_other" class="col-sm-4 control-label">Amount over ${{ clearanceFeeLookup[clearanceFeeLookup.length - 1].max + 1 }}</label>
            <div class="col-sm-8">
              <input id="shipment_value_other" type="number" class="form-control" name="shipment_value_other" v-model.number="shipment_value_other">
            </div>
          </div>
        </form>
        <hr>
        <div class="row">
          <div class="col-md-5 col-md-offset-7">
            <div class="calculator-subtotal">
              Transportation Fee: <span class="pull-right">{{transportation_fee | formattedPrice}}</span><br>
              Customs Clearance Fee: <span class="pull-right">{{clearance_fee | formattedPrice}}</span><br>
              E-Manifest Fee: <span class="pull-right">{{e_manifest_fee | formattedPrice}}</span><br>
            </div>
            <div class="calculator-total">
              <div class="line-total">
                <span class="total">Total:</span><sup>*</sup> <span class="pull-right">{{ total | formattedPrice }}</span>
              </div>
            </div>
          </div>
        </div>
        <p>
          <sup>*</sup>Additional charges may apply for special services. Customs Duties and Taxes and Pembina Warehouse charges will be added to your invoice.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {clearanceFeeLookup, singleParcelPrice, weightLookup} from '../pricing'

export default {
  data: () => ({
    shipment_type: 'Personal',
    shipment_weight: weightLookup[0].price,
    shipment_value: clearanceFeeLookup[0].price,
    shipment_weight_other: 0,
    shipment_value_other: 0,
    package_count: 1,
    clearanceFeeLookup,
    weightLookup,
  }),
  computed: {
    transportation_fee: function(){
      if(this.shipment_weight < 0){
        return this.shipment_weight_other * 7
      }

      return this.shipment_weight;
    },
    clearance_fee: function(){
      if(this.shipment_value < 0){
        var excess = Math.ceil(this.shipment_value_other/1000);
        return clearanceFeeLookup[clearanceFeeLookup.length - 1].price + (excess * 1000);
      }
      return this.shipment_value;
    },
    e_manifest_fee: function(){
      return 700;
    },
    total: function(){
      return this.transportation_fee + this.clearance_fee + this.e_manifest_fee;
    }
  }
}
</script>
